import React from 'react'
import PropTypes from 'prop-types'
import Scroll from 'react-scroll'
import Button from 'components/Button'

const scroll = Scroll.animateScroll

const ButtonScroll = ({ to, on, children, onClick, ...rest }) => {
	const handleClick = () => {
		if (onClick) onClick()
		setTimeout(() => {
			const rect = to.current.getBoundingClientRect()
			const pos = rect.y + window.pageYOffset
			const duration = 350

			if (on === 'top') {
				const offset = window.innerWidth < 768 ? 0 : -80
				scroll.scrollTo(pos + offset, { duration })
			}

			if (on === 'bottom') {
				const offset = window.innerWidth < 768 ? 60 : 0
				scroll.scrollTo(pos - window.innerHeight + rect.height + offset, { duration })
			}
		})
	}

	return (
		<Button type="button" onClick={handleClick} {...rest}>
			{children}
		</Button>
	)
}

ButtonScroll.defaultProps = {
	on: 'top',
}

ButtonScroll.propTypes = {
	to: PropTypes.object.isRequired,
	on: PropTypes.oneOf(['top', 'bottom']),
	onClick: PropTypes.func,
}

export default ButtonScroll
